<template>
  <div class="card-grid-display">
    <v-card class="mx-auto agenda-card" width="264" v-for="n in 2" :key="n">
      <v-card-text>
        <span class="text-subtitle-1 font-weight-bold">アジェンダ1</span>
        <div class="topic-grid-display">
          <v-row no-gutters v-for="n in 2" :key="n">
            <v-row no-gutters>
              <span class="text--topic ml-2"
                >トピック1トピック1トピック1トピック1トピック1トピック1</span
              >
            </v-row>
            <v-row no-gutters class="mt-2 ml-2">
              <v-col cols="auto">
                <a-chip outlined class="minute" small>999 min</a-chip>
              </v-col>
              <v-col cols="auto" class="pl-2">
                <v-icon size="20" class="mr-2">mdi-attachment</v-icon
                ><span class="primary--text">3</span>
              </v-col>
            </v-row>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AChip from "./AChip.vue";
export default {
  components: { AChip },
  name: "AgendaCard",
};
</script>

<style scoped>
.agenda-card {
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.agenda-card /deep/ .text-subtitle-1 {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
}

.agenda-card .v-card__text {
  padding: 12px !important;
  color: var(--v-darkCharcoal-base) !important;
}
.agenda-card /deep/ .text--topic {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* color: var(--v-darkCharcoal-base); */
}

.agenda-card /deep/ .topic-grid-display {
  display: grid;
  grid-gap: 14px;
}

.card-grid-display {
  display: grid;
  grid-gap: 8px;
}
</style>